module.exports = "/_next/static/files/0a51c630727195b72cd75a77bfb76b9e.svg";